import { render, staticRenderFns } from "./CategoriasForm.vue?vue&type=template&id=8307479c&scoped=true&"
import script from "./CategoriasForm.vue?vue&type=script&lang=js&"
export * from "./CategoriasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8307479c",
  null
  
)

export default component.exports